import '~/snippet/snippet_show';
import initAwardsApp from '~/emoji/awards_app';

initAwardsApp(document.getElementById('js-vue-awards-block'));
